import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=63aafa1a"
import script from "./ShoppingList.vue?vue&type=script&lang=js"
export * from "./ShoppingList.vue?vue&type=script&lang=js"
import style0 from "./ShoppingList.vue?vue&type=style&index=0&id=63aafa1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports